<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__indicators">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.ADD_INDICATORS }}</h3>
            <span class="modal__close"
                  @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg>
          </span>
          </div>
        </div>

        <Form class="modal__footer" @submit="submit" :initial-values="indicator" :validation-schema="indicatorSchema">
          <div class="input__group">
            <label for="indicator-name-input" class="label">{{ $lang.app.DENOMINATION }}</label>
            <Field name="name" v-slot="{ field, errorMessage }">
              <input v-bind="field"
                     type="text"
                     id="indicator-name-input"
                     class="input"
                     :class="{'input--fail': errorMessage }"
                     :placeholder="$lang.app.ENTER"
                     required>
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="input__group input__add__info">
                <label for="indicator-unit-of-measurement-input" class="label">{{ $lang.app.UNIT_OF_MEASUREMENT }}</label>
                <div class="select__wrapper">
                  <Field name="unitOfMeasurement" v-slot="{ field, errorMessage }">
                    <Multiselect
                        id="indicator-unit-of-measurement-input"
                        :attrs="{name: 'unitOfMeasurement'}"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        :options="unitOfMeasurements"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="id"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false"
                        required>
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="indicator-value-input" class="label">{{ $lang.app.VALUE }}</label>
                <Field name="value" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="indicator-value-input"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER"
                         required>
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>
          <div class="between__buttons">
            <button type="button" class="button button--cancel" @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="button button__modal__close">{{ $lang.app.SAVE }}</button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import * as yup from "yup";
import {Field, Form} from 'vee-validate';

export default {
  name: 'IndicatorModal',
  components: {
    Field, Form
  },
  props: {
    unitOfMeasurements: Array
  },
  data() {
    return {
      showModal: false,
      type: '',
      index: null,

      indicator: null,
      indicatorSchema: yup.object({
        name: yup.string().required(),
        unitOfMeasurement: yup.string().required(),
        value: yup.string().required(),
      }),
    }
  },
  beforeMount() {
    this.$emitter.on('open-indicator-modal', (payload) => {
      this.type = 'CREATE'
      this.indicator = {
        name: '',
        unitOfMeasurement: '',
        value: ''
      }
      if(payload.type === 'EDIT') {
        this.type = 'EDIT'
        this.index = payload.index
        this.indicator = payload.indicator
      }
      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-indicator-modal')
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    submit(values) {
      if(this.type === 'CREATE') {
        this.$emit('create-indicator', {indicator: values})
      }
      if(this.type === 'EDIT') {
        this.$emit('edit-indicator', {index: this.index, indicator: values})
      }

      this.closeModal()
    }
  }
}
</script>